export default function PHP_MySQLWhere() {
  return (
    <div>
      <h1>PHP_MySQLWhere</h1>
    </div>
  );
}
